import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { ProfileItemEntity } from '../../domain/profile-item.entity';
import { ProfileListEntity } from '../../domain/profile-list.entity';

@Injectable()
export class ProfileListProvider {
	private readonly profileList: ProfileListEntity;

	public constructor() {
		this.profileList = ProfileListEntity.build([
			{
				field: 'label',
				alias: $localize`:i18n=@@subscription.profile.list.column.label:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: true,
				visibleIndex: 0,
			},
			{
				field: 'description',
				alias: $localize`:i18n=@@subscription.profile.list.column.description:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: false,
				visibleIndex: 1,
			},
			{
				field: 'columnModelId',
				alias: $localize`:i18n=@@subscription.profile.list.column.columns:`,
				type: '',
				hasHeaderFilter: false,
				isSearchable: false,
				isFilterable: false,
				visibleIndex: 2,
			},
			{
				field: 'filterModelIds',
				alias: $localize`:i18n=@@subscription.profile.list.column.filters:`,
				type: '',
				hasHeaderFilter: false,
				isSearchable: false,
				isFilterable: false,
				visibleIndex: 3,
			},
			{
				field: 'status',
				alias: $localize`:i18n=@@subscription.profile.list.column.status:`,
				type: '',
				hasHeaderFilter: false,
				isSearchable: false,
				isFilterable: false,
				visibleIndex: 4,
			},
		]);
	}

	public getList(): ProfileListEntity {
		return this.profileList;
	}

	public setListElements(
		elements: Map<string, ProfileItemEntity>
	): ProfileListEntity {
		return this.profileList.setElements(elements);
	}
}
